import { React, useState, useRef, useEffect } from "react";
import ClientLayout from "../../client/components/layout/ClientLayout";
//
export default function StartUpPopUp({ onClose }) {
  const [showModal, setShowModal] = useState(false);
  const closeButton = () => {
    setShowModal(false);
  };
  return (
    <>
      <style>
        {`
                .modal-content-style {
                    max-width: 1000px !important;
                    width: 100% !important;
                    max-height: 95vh !important;
                    background-color: #ffff;
                    color: #000
                }
                `}
      </style>

      <div
        class="modal fade show"
        id="modalMarketRules"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalMarketRules"
        style={{ display: "block", paddingLeft: "0px" }}
      >
        <div
          class="modal-dialog modal-lg"
          role="document"
          style={{ top: "43%" }}
        >
          <div class="modal-content modal-content-style">
            <div
              class="modal-header"
              style={{
                borderBottom: "0px",
                padding: "1px",
                background: "white"
              }}
            >
              <div class="modal-title" id="exampleModalLabel"></div>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                style={{
                  color: "white",
                  margin: "-1.1rem -0.7rem -0.9rem auto"
                }}
              >
                <span
                  aria-hidden="true"
                  style={{ color: "#000", opacity: "0.8" }}
                  onClick={onClose}
                >
                  ×
                </span>
              </button>
            </div>
            <div
              id="market-rules-text"
              class="modal-body"
              style={{ textAlign: "center", padding: "8px 0px 0px 0px" }}
            >
              <div class="container-fluid">
                <div data-typeid="" class="row rules-container">
                  <div class="col nopading rules-description">
                    <a href="/tp-studio/chickenroad">
                      <img
                        class="img-responsive img-fluid"
                        src="./assets/images/BannerDefault.jpeg"
                        alt="Box Icon"
                        style={{ width: "100%" }}
                      />
                    </a>
                  </div>
                </div>
                <div style={{ height: "9px" }}></div>
                <div class="modal-footer" style={{ padding: "0px 0px" }}>
                  <button
                    type="button"
                    class="btn btn-sm btn-secondary"
                    data-dismiss="modal"
                    aria-label="Close"
                    style={{
                      color: "white",
                      margin: "-0.5rem -0.7rem -1rem auto",
                      height: "26px",
                      padding: "4px"
                    }}
                  >
                    <span
                      aria-hidden="true"
                      style={{ color: "#fff", opacity: "0.8" }}
                      onClick={onClose}
                    >
                      Close
                    </span>
                  </button>
                </div>
                <div>&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
